module.exports = __webpack_public_path__ + "img/icon1.c80097ef.png";